// extracted by mini-css-extract-plugin
export default {"container":"App__container___EE3cS"};